import { useRef, useEffect } from 'react';

const useAutoFocus = (dependency?: any): React.RefObject<HTMLInputElement> => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef?.current?.focus();
    }
  }, [inputRef, dependency]);

  return inputRef;
};

export default useAutoFocus;
